"use strict";
/**
 * Created by Pankaj on 2019-03-04.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayFilterTypes = void 0;
var ReplayFilterTypes;
(function (ReplayFilterTypes) {
    ReplayFilterTypes["MONETARY"] = "monetary";
    ReplayFilterTypes["MULTIPLIER"] = "multiplier";
})(ReplayFilterTypes = exports.ReplayFilterTypes || (exports.ReplayFilterTypes = {}));
//# sourceMappingURL=ReplayFilterTypes.js.map